import { connect } from 'react-redux';
import { get } from 'lodash/fp';
import { toStandardDate } from '../../../helpers/dates';
import {
  getLocationOptions,
  getIsSaving,
  getIsSaved,
  getIsFetchingDonorOptions,
  getDonorOptions
} from '../../../redux/Inventory/selectors/components/adjust-item-form';

import {
  adjustInventoryPackage,
  fetchInventoryPackageAvailability,
  fetchInventoryLocationOptions,
  fetchInventoryDonorOptions
} from '../../../redux/Inventory/sagas/routines';
import InventoryAdjustPackageForm from '../../../components/inventory/AdjustPackageForm';

function mapStateToProps(state, props) {
  return {
    ...props,
    locationId: get('packageItems.0.location.id', props),
    locationOptions: getLocationOptions(state),
    donorOptions: getDonorOptions(state),
    isFetchingDonors: getIsFetchingDonorOptions(state),
    isSaving: getIsSaving(state),
    isSaved: getIsSaved(state)
  };
}

function mapDispatchToProps(dispatch, { item: { id } }) {
  return {
    onInit: () => {
      dispatch(fetchInventoryLocationOptions());
      dispatch(fetchInventoryDonorOptions());
    },
    onSubmit: ({ performedOn = null, ...formData }) => {
      const body = performedOn
        ? { ...formData, performedOn: toStandardDate(performedOn) }
        : formData;
      dispatch(adjustInventoryPackage({ id, body }));
    },
    onSaved: () => {
      dispatch(fetchInventoryPackageAvailability(id));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InventoryAdjustPackageForm);
